let deploymentTypes = {
  localDevelopment: "development",
  development: "development",
  production: "production",
};

// Function to check if the current environment is UAT
const isUATEnvironment = () => {
  // Check if the current URL contains 'uat'
  return window.location.href.toLowerCase().includes("uat");
};

let servers = {
  localDevelopment: "localhost",
  development: isUATEnvironment() ? "uat-api.loanlinq.com" : "api.loanlinq.com",
  production: isUATEnvironment() ? "uat-api.loanlinq.com" : "api.loanlinq.com",
};
let serverType = deploymentTypes.development;

const PROD_BASE_URL = "https://support.loanlinq.com";
const UAT_BASE_URL =
  "https://ga84e97f5555b7d-llqdevatpuat.adb.us-sanjose-1.oraclecloudapps.com";

const PROD_BASE_URL_NODE = "https://api.loanlinq.com";
const UAT_BASE_URL_NODE = "https://uat-api.loanlinq.com";

// Function to get the appropriate base URL based on environment
const getBaseUrl = () => {
  return isUATEnvironment() ? UAT_BASE_URL : PROD_BASE_URL;
};

const getBaseUrlForNodeAPIS = () => {
  return isUATEnvironment() ? UAT_BASE_URL_NODE : PROD_BASE_URL_NODE;
  // return isUATEnvironment() ? PROD_BASE_URL_NODE : PROD_BASE_URL_NODE;
};

let basic_auth_header_token = btoa("RESTAPILOANLINQ:88WeHelpU$#@"); // : and / both creates same base64 code. Update=> : worked and / failed.
let authentication_servers = {
  node_server: {
    server: "node_server",
    token: {
      endpoint: `${getBaseUrlForNodeAPIS()}/api/v1/services/session/token`,
      authorization: "",
    },
    login: {
      endpoint: `${getBaseUrlForNodeAPIS()}/api/v1/rest/user/login.json`,
      authorization: "",
    },
  },
  apex_server: {
    server: "apex_server",
    auth_token: {
      endpoint: "http://localhost:8085/api/v1/auth/get_auth_token",
      authorization: "",
    },
    registerVerify: {
      endpoint: `${getBaseUrl()}/ords/loanlinq/v1/validate_reg_user`,
      authorization: basic_auth_header_token,
      headers: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + basic_auth_header_token,
        },
      },
    },
    register: {
      endpoint: `${getBaseUrl()}/ords/loanlinq/v1/registerprofile`,
      authorization: basic_auth_header_token,
      headers: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + basic_auth_header_token,
        },
      },
    },
    login: {
      endpoint: `${getBaseUrl()}/ords/loanlinq/v1/authenticate`,
      authorization: basic_auth_header_token,
      headers: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + basic_auth_header_token,
        },
      },
    },
    add_account: {
      endpoint: `${getBaseUrl()}/ords/loanlinq/v1/addaccount`,
      authorization: basic_auth_header_token,
      headers: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + basic_auth_header_token,
        },
      },
    },
    access_account: {
      endpoint: `${getBaseUrl()}/ords/loanlinq/v1/useraccess`,
      authorization: basic_auth_header_token,
      headers: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + basic_auth_header_token,
        },
      },
    },
    msa_accepted: {
      endpoint: `${getBaseUrl()}/ords/loanlinq/v1/msa_accepted`,
      authorization: basic_auth_header_token,
      headers: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + basic_auth_header_token,
        },
      },
    },
    // get request
    // append email of user whose ID is required at end
    user_by_email: {
      endpoint: `${getBaseUrl()}/ords/loanlinq/v1/allusers/`,
      authorization: basic_auth_header_token,
      headers: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + basic_auth_header_token,
        },
      },
    },
    new_user_admission: {
      endpoint: `${getBaseUrl()}/ords/loanlinq/v1/lead`,
      authorization: basic_auth_header_token,
      headers: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + basic_auth_header_token,
        },
      },
    },
    lender_onboarding: {
      endpoint: `${getBaseUrl()}/ords/loanlinq/v1/`,
      authorization: basic_auth_header_token,
      headers: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + basic_auth_header_token,
        },
      },
    },
    ticket_attachment: {
      endpoint: `${getBaseUrl()}/ords/loanlinq/v1/incident_attachment`,
      authorization: basic_auth_header_token,
      headers: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + basic_auth_header_token,
        },
      },
    },
  },
};

let selected_authentication_server = authentication_servers.apex_server;

module.exports = {
  deploymentTypes,
  servers,
  serverType,
  selected_authentication_server,
};
